import React, { useState, useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./DashboardContent.css";
import { Tabs, Tab, Box} from "@mui/material";
import MyQueries from "./MyQueries";
import QueriesAnswered from "./QueriesAnswered";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { fetchDashboardStats } from "../../store/dashboardSlice";

const DashboardContent = () => {
  const [tabValue, setTabValue] = useState(0);
  const [totalQuestionsCount, setTotalQuestionsCount] = useState(0);

  const theme = createTheme({
    typography: {
      fontFamily: "Graphik-Regular",
    },
  });
  const dispatch = useDispatch();
  const { stats, statsLoading  } = useSelector((state) => state.dashboard);
  const { accounts } = useMsal();
  const loggedInUserId = accounts?.[0]?.idTokenClaims?.oid;

  useEffect(() => {
    if (loggedInUserId) {
      dispatch(fetchDashboardStats(loggedInUserId));
    }
  }, [dispatch, loggedInUserId]);
  const statsData = [
    {
      icon: "/images/Dashboard/answers_icon.png",
      count: stats?.totalAnswersProvided || 0,
      label: "Answers provided",
    },
    {
      icon: "/images/Dashboard/best_answers_icon.png",
      count: stats?.totalBestAnswers || 0,
      label: "Best answers",
    },
    {
      icon: "/images/Dashboard/questions_icon.png",
      count: stats?.totalQuestionsAsked || 0,
      label: "Questions asked",
    },
    {
      icon: "/images/Dashboard/likes_icon.png",
      count: stats?.totalLikesReceived || 0,
      label: "Total likes",
    },
    {
      icon: "/images/Dashboard/points_icon.png",
      count: stats?.totalPoints || 0,
      label: "Total points",
    },
  ];
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const headerTitle =
  tabValue === 0 ? "My Queries" : "Queries I Answered";
  
  return (
    <ThemeProvider theme={theme}>
      <div className="homebanner_container">
        <img
          src={process.env.PUBLIC_URL + "/images/Dashboard/dashboard_banner.png"}
          alt="banner"
          className="homeBannerImg"
        />
        <div className="dashboardbannerContentSection">
          <p>My Dashboard</p>
        </div>
      </div>
      <div className="dashboardStatsWrapper">
        {statsData.map((item, index) => (
          <div className="statItem" key={index}>
            <img
              src={process.env.PUBLIC_URL + item.icon}
              alt={item.label}
              className="statIcon"
            />
            <div className="statContent">
              <span className="statCount">{item.count}</span>
              <span className="statLabel">{item.label}</span>
            </div>

            {index !== statsData.length - 1 && (
              <div className="statDivider"></div>
            )}
          </div>
        ))}
      </div>
      <div className="dashboardQueriesSection">
        <div className="dashboardQueriesHeader">
          <div>
            <h2 className="dashboardTitle">{headerTitle}</h2>
            {tabValue === 0 ? (
              <p className="dashboardSubtitle">
                Total Questions: {totalQuestionsCount}
              </p>
            ) : (
                <p className="dashboardSubtitle">
                  Total Answers: {stats?.totalAnswersProvided || 0}
                </p>
            )}
          </div>

          <Tabs
            value={tabValue}
            onChange={handleChange}
            className="dashboardTabs"
          >
            <Tab label="My Queries" />
            <Tab label="Queries I Answered" />
          </Tabs>
        </div>
        <Box className="dashboardTabContent">
          {tabValue === 0 && (
            <MyQueries setTotalCount={setTotalQuestionsCount} />
          )}

          {tabValue === 1 && (
            <QueriesAnswered />
          )}
        </Box>
      </div>
    </ThemeProvider>
  );
};

export default DashboardContent;